import { FC, useState, useEffect } from 'react';
import './style.scss';
import Steps from './steps';
import PromisePlugin from './promise';
import Form from './form';
import Application from './application';
import Material from './material';
import Pre from './pre';
import Upload from './upload';
import Success from './success';
import { Modal, UploadFile, Button } from 'antd';
import { getUserInfoApi, listByTypesApi, getByApplicantIdCardApi } from '../api';
import { getQueryVariable, utf8_to_b64, b64_to_utf8, unPassWordFiled } from '../utils';
import { FILED_MAP, FR_FILED_MAP } from './data';
import { FileType, CLINIC, NET, CLINIC_TYPE, OTHER } from './enum';
import { zrrData, farData } from './form/data';
import { formSchemaData } from './application/data';
import { forEach } from 'lodash-es';
import moment from 'moment';

const { confirm } = Modal;

const View: FC = () => {
    const [proStatus, setProStatus] = useState<boolean>(false);
    const [current, setCurrent] = useState<number>(0);
    const [nextParam, setNextParam] = useState<any>({});
    const [selectOptions, setOptions] = useState<Record<string, any>[]>([]);

    const [fromData, setFromData] = useState<Record<string, any> | null>(null);
    const [appFromData, setAppFromData] = useState<Record<string, any> | null>(null);

    const [open, setOpen] = useState(false);
    const [openLoginType, setOpenLoginType] = useState(false);
    function handleCancelLoginType() {
        setOpenLoginType(false);
        window.location.replace('https://rzsc.sczwfw.gov.cn/logon/password.jsp?state=nologin');
        // window.location.href = 'https://rzsc.sczwfw.gov.cn/logon/password.jsp?state=nologin';
    }
    function toLoginType(){
        setOpenLoginType(false);
        window.location.replace('https://rzsc.sczwfw.gov.cn/logon/password.jsp?state=nologin');
        // window.location.href = 'https://rzsc.sczwfw.gov.cn/logon/password.jsp?state=nologin';

    }
    function handleCancel() {
        setOpen(false);
    }

     function toLogin() {
        setOpen(false);
        window.location.replace('https://rzsc.sczwfw.gov.cn/logon/password.jsp?state=nologin');
        // window.location.href = 'https://rzsc.sczwfw.gov.cn/logon/password.jsp?state=nologin';
    }

    const [materialList, setMaterialList] = useState([
        {
            fileName: '广告成品样件（注: 上传类型需和“广告申请”勾选一致）',
            uploadResult: [] as UploadFile[],
            type: FileType.BANNER
        },
        // {
        //     fileName: '医疗机构执业许可证正副本/备案诊所证/诊所备案凭证',
        //     uploadResult: [] as UploadFile[],
        //     type: FileType.PERMIT
        // },
        {
            fileName: '医疗广告审查申请表',
            type: FileType.APPLY
        },
        {
            fileName: '医疗广告成品样件表',
            type: FileType.SAMPLE
        }
    ]);
    //
    const [materialUpLoadList, setMaterialUpLoadList] = useState([
        {
            fileName: '医疗机构执业许可证正副本/备案诊所证/诊所备案凭证',
            uploadResult: [] as UploadFile[],
            type: FileType.PERMIT,
            subText: '(注:医院和门诊部请上传许可证正本和副本以及副本校验页)'
        },
        {
            fileName: '医疗广告审查申请表',
            type: FileType.APPLY,
            uploadResult: [] as UploadFile[],
            subText: '(注:请采用智能预审生成表格，盖章后扫描成PDF文件上传)'
        },
        {
            fileName: '医疗广告成品样件表',
            type: FileType.SAMPLE,
            uploadResult: [] as UploadFile[],
            subText: '(注:请采用智能预审生成表格，盖章后扫描成PDF文件上传)'
        }
    ]);
    // 用户登录信息
    const [userInfo, setUserInfo] = useState<Record<string, unknown>>({});

    useEffect(() => {
        const code = getQueryVariable('code');
        const userData = window.sessionStorage.getItem('userinfo');

        if (userData) {
            setUserInfo(JSON.parse(userData));
             if(JSON.parse(userData).type === 'user'){
                setOpenLoginType(true);
            }
        } else {
            getUserInfoApi({ code }).then(({ data }) => {
                if (!data) setOpen(true);
                if (data) window.sessionStorage.setItem('userinfo', JSON.stringify(data));
                if(data && data.type === 'user') setOpenLoginType(true);
                setUserInfo(data || {});
            });
        }
        listByTypesApi({
            types: 'ownership,category_wj,area,org_property,media'
        }).then(({ data }) => setOptions(data));
        return () => {
            window.sessionStorage.removeItem('userinfo');
          };
    }, []);

    function promiseRadio({ target }: any) {
        setProStatus(target.checked);
    }

    function getFormValue(data: any, field: string) {
        try {
            // eslint-disable-next-line no-new-func
            const fn = new Function(`return this.${field};`);
            return fn.bind(data)() || '';
        } catch (error) {
            return '';
        }
    }

    async function setAppLicationFromData() {
        const {
            contactName,
            contactPhone,
            contactIdCard,
            legalPerson,
            legalPersonIdCard,
            orgName,
            orgAddress,
            applicantIdCard
        } = fromData as any;

        let aplayData: any = {
            contactName,
            contactPhone,
            contactIdCard,
            idCard: legalPersonIdCard,//企业账号没有legalPersonIdCard//legalPersonCard
            legalPerson,
            address: orgAddress,
            orgName,
            applicantIdCard
        };

        try {
            const { data, code } = await getByApplicantIdCardApi({
                applicantIdCard: utf8_to_b64(applicantIdCard)//申请人
                //applicantIdCard: utf8_to_b64(contactIdCard)//经办人
            });
            if (data && code === 200) {
                const newaplayData: Record<string, any> = unPassWordFiled(formSchemaData, data);
                // forEach(data, (val, key) => (newaplayData[key] = b64_to_utf8(val)));
                if (typeof newaplayData.media === 'string')
                    newaplayData.media = newaplayData.media.split(',');

                // 转换接诊时间
                if (typeof newaplayData.receptionTime === 'string') {
                    const times = newaplayData.receptionTime.split(',');
                    const startTime = moment(times[0], 'HH:mm').format('HH:mm');
                    const endTime = moment(times[1], 'HH:mm').format('HH:mm');
                    newaplayData.receptionTime = [startTime, endTime];
                }

                // 单独转换申请人证件
                if (newaplayData.applicantIdCard)
                    newaplayData.applicantIdCard = b64_to_utf8(newaplayData.applicantIdCard);

                aplayData = newaplayData;
            }
        } catch (error) {}

        const showData: any = {};
        forEach(formSchemaData, (item: any) =>
            forEach(item.schema, ({ showFiled, format, filed }) => {
                if (showFiled && format) showData[showFiled] = format(aplayData[filed]);
            })
        );
        setAppFromData({ ...aplayData, ...showData });
    }

    function next(index: number, key?: string, patam?: any) {
        if (key) setNextParam({ ...nextParam, [key]: patam });

        setCurrent(index);
        if (index === 2 ) setAppLicationFromData();

        if (index === 1 && !fromData) {
            const fileMap = userInfo.type === 'user' ? FILED_MAP : FR_FILED_MAP;
            confirm({
                title: '提 示',
                content: '是否需要自动填充用户信息？',
                cancelText: '否',
                okText: '是',
                onOk() {
                    const data: any = {};
                    for (const key in fileMap) {
                        data[key] = getFormValue(userInfo.dataInfo || {}, (fileMap as any)[key]);
                    }
                    const showData: any = {};
                    forEach(userInfo.type === 'user' ? zrrData : farData, (item: any) =>
                        forEach(item.schema, ({ showFiled, format, filed }) => {
                            if (showFiled && format) showData[showFiled] = format(data[filed]);
                        })
                    );
                    setFromData({ ...data, ...showData }); // 获取当前用户信息 --- 请求表单数据
                },
                onCancel() {
                    setFromData({});
                }
            });
        }
    }

    function successClick() {
        setProStatus(false);
        setFromData({});
        setCurrent(0);
        setNextParam({});
        setMaterialList(
            materialList.map((item) => {
                if (item.uploadResult) item.uploadResult = [];
                return { ...item };
            })
        );
    }

    function formChange(fields: any, value: any) {
        if (typeof fields === 'object') {
            setFromData({ ...fromData, [fields[0]]: value, [fields[1]]: value });
        } else {
            setFromData({ ...fromData, [fields]: value });
        }
    }

    function appFormChange(fields: string, value: any) {
        const newData = !fields
            ? { ...appFromData, ...value }
            : { ...appFromData, [fields]: value };
        // 床位数值特殊处理
        if (fields === 'category_wj' && CLINIC.includes(value)) newData.bed = null;
        // 诊所屏蔽检验有效期
        if (fields === 'category_wj' && CLINIC_TYPE.includes(value)) {
            newData.endValidDate = null;
            newData.startValidDate = null;
        }

        // 媒体类型特殊处理
        if (fields === 'media' && !!newData.media && !newData.media?.includes(NET))
            newData.publish = null;

        if (fields === 'media' && !!newData.media && !newData.media?.includes(OTHER))
            newData.other = null;

        setAppFromData(newData);
    }

    function renderContent(current: number) {
        switch (current) {
            case 0:
                return <PromisePlugin status={proStatus} next={next} promiseRadio={promiseRadio} />;
            case 1:
                return (
                    <Form
                        next={next}
                        isperson={userInfo.type === 'user'}
                        data={fromData}
                        onChange={formChange}
                    />
                );
            case 2:
                return (
                    <Application
                        next={next}
                        options={selectOptions}
                        data={appFromData}
                        nextParam={nextParam}
                        onChange={appFormChange}
                    />
                );
            case 3:
                return (
                    <Material
                        next={next}
                        tableData={materialList}
                        setTableData={setMaterialList}
                        nextParam={nextParam}
                        options={selectOptions}
                    />
                );
            case 4:
                return <Pre next={next} nextParam={nextParam} />;
            case 5:
                return (
                    <Upload
                        next={next}
                        tableData={materialUpLoadList}
                        setTableData={setMaterialUpLoadList}
                        nextParam={nextParam}
                        options={selectOptions}
                        uuid={userInfo.type === 'user' ? (userInfo.dataInfo as any)?.naturalBase?.uuid ?? '': (userInfo.dataInfo as any)?.legalBase?.uuid ?? ''}
                    />
                );
            case 6:
                return (
                    <Success
                        next={next}
                        idCard={userInfo.type === 'user' ? utf8_to_b64((userInfo.dataInfo as any)?.real?.certNo ?? '') : utf8_to_b64((userInfo.dataInfo as any)?.legalBase?.currentPerson_Info?.idNumber?? '')}
                        nextParam={nextParam}
                        uuid={userInfo.type === 'user' ? (userInfo.dataInfo as any)?.naturalBase?.uuid ?? '': (userInfo.dataInfo as any)?.legalBase?.uuid ?? ''}
                    />
                );
        }
    }

    return (
        <div className='view-box'>
            <div className='steps-box'>
                <Steps current={current} />
            </div>
            <div className='tite-box'>
                <div className='title'>医疗广告审查</div>
                <div className='content'>
                    <div className='content-item'>
                        <div className='label'>法定办结时限:</div>
                        <div className='value'>20个工作日</div>
                    </div>
                    <div className='content-item'>
                        <div className='label'>承诺办结时间:</div>
                        <div className='value'>8个工作日</div>
                    </div>
                    <div className='content-item'>
                        <div className='label'>办理地点:</div>
                        <div className='value'>
                        四川省-成都市-青羊区-草市街道-2号,详细地址：四川省成都市草市街2号 省政务服务和公共资源交易中心5楼7-01、02号窗口;
                        </div>
                    </div>
                </div>
            </div>
            {renderContent(current)}
            <Modal
                title={null}
                open={open}
                wrapClassName='modal-login'
                footer={null}
                onCancel={handleCancel}
                destroyOnClose={true}
                width={450}
                style={{ textAlign: 'center', top: '35%' }}
                maskClosable={false}  // 点击遮罩层不关闭
                closable={false}
            >
                <div style={{ textAlign: 'left', fontSize: '16px', marginTop: '-10px' }}>注意</div>
                <div style={{ padding: '10px' }}>您还未登录，请登录后进行操作</div>
                <div style={{ textAlign: 'right', marginTop: '15px' }}>
                    <Button type='primary' onClick={toLogin}>
                        确定
                    </Button>
                </div>
            </Modal>
            <Modal
                title={null}
                open={openLoginType}
                wrapClassName='modal-login'
                footer={null}
                onCancel={handleCancelLoginType}
                destroyOnClose={true}
                width={450}
                style={{ textAlign: 'center', top: '35%' }}
                maskClosable={false}  // 点击遮罩层不关闭
                closable={false}  // 隐藏关闭按钮
               
            >
                <div style={{ textAlign: 'left', fontSize: '16px', marginTop: '-10px' }}>温馨提示</div>
                <div style={{ padding: '10px' }}>您当前身份与待办事项服务对象类型不匹配<br/>请用法人账号登录!</div>
                <div style={{ textAlign: 'right', marginTop: '15px' }}>
                    <Button type='primary' onClick={toLoginType}>
                        确定
                    </Button>
                </div>
            </Modal>
        </div>
    );
};

export default View;
